import { URL_LABEL } from "../../../../../content/index.content";
import { ICONS } from "../../../../../content/index.content";

const aiListingBuilder = ({ language, isSavedUser }) => {
  return {
    title: "AI Listing Builder",
    href: `/app/#/builder/?${URL_LABEL}`,
    subtitle:
      "Build a unique listing for your product using only the most popular keywords, and stand out from the competition",
    icon: ICONS.NEW,
  };
};

export default aiListingBuilder;
